export default __webpack_public_path__ + "static/media/team-maureen.288747f6.webp";